import type { GraphQLError } from 'graphql';

import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import {
	onboardingStateGetOnboardingStateQuery,
	type onboardingStateGetOnboardingStateQuery$data,
	type onboardingStateGetOnboardingStateQuery$variables,
} from '@confluence/onboarding-helpers/entry-points/onboardingStateGetOnboardingStateQuery.ts';
import { ONBOARDING_EXPERIENCES } from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants.ts';

export async function preloadOmnibar(): Promise<{
	data: onboardingStateGetOnboardingStateQuery$data | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> {
	return query<
		onboardingStateGetOnboardingStateQuery$data,
		onboardingStateGetOnboardingStateQuery$variables
	>({
		query: onboardingStateGetOnboardingStateQuery,
		variables: {
			key: [ONBOARDING_EXPERIENCES.IS_FOUNDING_ADMIN],
		},
	});
}
